export const headers = ["h2", "h3", "h4", "h5", "h6"] as const;

export function getHeadingLevel(
  componentHeader: boolean,
  tease: boolean,
  headerAbove: boolean,
  resetHeaders?: "h2" | "h3" | "h4",
): "h2" | "h3" | "h4" | "h5" | "h6" {
  // Defaults
  if (!headerAbove && !resetHeaders && !tease) {
    return "h2";
  } else if (!headerAbove && !resetHeaders && tease) {
    return componentHeader ? "h3" : "h2";
  }

  if (resetHeaders && headers.includes(resetHeaders)) {
    if (!tease) {
      return resetHeaders;
    } else {
      const next = headers[headers.indexOf(resetHeaders) + 1];
      return componentHeader && next ? next : resetHeaders;
    }
  } else {
    if (!tease) {
      return headerAbove ? "h3" : "h2";
    } else {
      return headerAbove
        ? componentHeader
          ? "h4"
          : "h3"
        : componentHeader
          ? "h3"
          : "h2";
    }
  }
}
